import React from "react"
import { Form2 } from "@cd2/forms"
import { brandColors } from "../Components/EOSThemeProvider"

const colors = {
  green: "#27ae60",
  blue: "#3498db",
  red: "#ac242d",
}

const buttonTheme = {
  padding: { topAndBottom: 14, sides: 14 },
}

export function NewForm2Submit({ value, disabled }: { value?: string; disabled?: boolean }) {
  const useDisabled: { disabled?: boolean } = {}
  if (typeof disabled !== "undefined") {
    useDisabled.disabled = disabled
  }
  return (
    <div>
      <Form2.Submit
        buttonProps={{
          theme: {
            color: "white",
            buttonColor: brandColors.darkMint,
            ...buttonTheme,
          },
          ...useDisabled,
        }}
        value={value}
      />
    </div>
  )
}
